import { useStore } from 'zustand';
import { useGridStoreApiOptional } from './GridStoreProvider';
import { GridStoreApi, emptyGridStore } from './gridStore';
import { GridCellState, UseCellParams } from './gridStore.types';

interface UseCellResult {
  api: GridStoreApi | null;
  cell: GridCellState | undefined;
}

export const useCell = ({ combinationKey, skuId }: UseCellParams): UseCellResult => {
  const api = useGridStoreApiOptional();
  const cell = useStore(api ?? emptyGridStore, (state) => state.cells[combinationKey]?.[skuId]);

  return { api, cell };
};
